import {selectOptionData} from "../dynamic-form-question/dynamic-form-question.component";
import {SectionAnswerMessage} from "./answer-messages";

export interface Section{
  number: number;
  description: string;
  namespace: string;
  sectionKey: string;
  expanded: boolean;
  callBackFunction: string;
  // SCRUM-154: optional section guidance + "upgrade your ad" banner.
  helpText?: string | null;
  showUpgradeBanner?: boolean;
  upgradeBannerTitle?: string | null;
  upgradeBannerText?: string | null;
  // SCRUM-231: messages shown when a question here gets a given answer.
  answerMessages?: SectionAnswerMessage[];
}

export class QuestionBase<T> {
  value: any;
  key: string;
  keyArr: string;
  label: string;
  required: boolean;
  regex: string;
  order: number;
  controlType: string;
  type: string;
  page: number;
  section: Section | {};
  options: selectOptionData[];
  callBackFunction: string;
  relatedField: string;
  additionalParam: string;
  bindSelectHide: boolean;
  addClass: string;
  parentMapValue: string
  dropDownLabels: string[]
  disabled: boolean;
  // SCRUM-154: key of a checkbox; when it is ticked this question is hidden
  // and not required (e.g. "Test until" once "No test" is ticked).
  requiredUnless: string;
  // SCRUM-155: guidance under the field (one line per row) + character limit.
  hint: string;
  maxLength: number | null;
  // How a text answer is typed / shown / stored (price, km, licensePlate...),
  // see shared/field-format.ts.
  inputFormat: string;
  constructor(options: {
    value?: T;
    key?: string;
    keyArr?: string;
    label?: string;
    required?: boolean;
    regex?: string;
    order?: number;
    controlType?: string;
    type?: string;
    page?: number;
    section?:{
      number: number;
      description: string;
      namespace: string;
      expanded: boolean;
      sectionKey: string;
      callBackFunction: string;
    };
    options?: selectOptionData[];
    callBackFunction?: string;
    relatedField?: string;
    additionalParam?: string;
    bindSelectHide?: boolean;
    addClass?: any;
    parentMapValue?: string;
    dropDownLabels?: string[];
    disabled?: boolean
    requiredUnless?: string

  } = {}) {
    this.value = options.value;
    this.key = options.key || '';
    this.keyArr = options.keyArr || '';
    this.label = options.label || '';
    this.required = !!options.required;
    this.regex = options.regex || '';
    this.order = options.order === undefined ? 1 : options.order;
    this.controlType = options.controlType || '';
    this.type = options.type || '';
    this.page = options.page || 1;
    this.section = options.section || {}
    this.options = options.options || [];
    this.callBackFunction = options.callBackFunction || '';
    this.relatedField = options.relatedField || '';
    this.additionalParam = options.additionalParam || '';
    this.bindSelectHide = options.bindSelectHide || false;
    this.addClass = options.addClass;
    this.parentMapValue = options.parentMapValue;
    this.dropDownLabels = options.dropDownLabels || [];
    this.disabled = options.disabled
    this.requiredUnless = options.requiredUnless || '';
    this.hint = '';
    this.maxLength = null;
    this.inputFormat = '';
  }
}

